export const LOCAL_STORAGE_TOKEN = 'auth0Cypress';
